import React from 'react';

import {
  FiltersWrapper,
  MoreParams,
} from '@/modules/CarsStock/components/common.styles';
import AllParamsButton from '@/modules/CarsStock/components/Desktop/components/AllParamsButton';
import { useTypedSelector } from '@/store/store';
import { getShowMoreParams } from '@/store/reducers/cars-stock';

import BatteryCapacityFilter from './components/BatteryCapacityFilter';
import WheelFilter from './components/WheelFilter';
import PriceFilter from './components/PriceFilter';
import BodyFilter from './components/BodyFilter/BodyFilter';
import PowerReserveFilter from './components/PowerReserveFilter';
import ColorFilter from './components/ColorFilter';
import BatteryTypeFilter from './components/BatteryTypeFilter';
import LocationFilter from './components/LocationFilter';
import SpecialFilter from './components/SpecialFilter';

export function ParamsFilterElectric() {
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  return (
    <React.Fragment>
      <FiltersWrapper>
        <BatteryCapacityFilter />
        <WheelFilter />
        <PriceFilter />
      </FiltersWrapper>

      <AllParamsButton />

      <MoreParams isVisible={isShowMoreParams}>
        <FiltersWrapper>
          <BodyFilter />
          <PowerReserveFilter />
          <ColorFilter />
          <BatteryTypeFilter />
          <LocationFilter />
        </FiltersWrapper>
      </MoreParams>

      <SpecialFilter />
    </React.Fragment>
  );
}
